'use client';

// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import charts, all with Chart suffix
import { PieChart } from 'echarts/charts';
// import components, all suffixed with Component
import { GridComponent, PolarComponent, TooltipComponent } from 'echarts/components';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {
//   CanvasRenderer,
SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo, useState } from 'react';
type Props = {
  data: {
    id: string;
    value: number;
    name: string;
  }[];
  total?: number;
};

// Register the required components
echarts.use([TooltipComponent, GridComponent, PolarComponent, PieChart, SVGRenderer]);
export const QuarkDomainsDistribution: FC<Props> = (props: Props) => {
  const {
    data,
    total = 12
  } = props;
  const theme = useTheme();
  const getDomainOpacity = (value: number) => {
    switch (value) {
      case 1:
        return 1;
      case 2:
        return 0.8;
      case 3:
        return 0.6;
      default:
        return 0.2;
    }
  };
  const [max, setMax] = useState(data[0].value);
  const [customData, setCustomData] = useState(data.map(item => {
    return {
      value: item.value,
      name: item.name,
      itemStyle: {
        opacity: item.value / max
      }
    };
  }));
  const option = useMemo(() => ({
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (params: any) => {
        return `${params.name} :<br />
                  ${params.value} compétence${params.value > 1 ? 's' : ''} (${params.percent}%)`;
      }
    },
    series: [{
      name: 'Totems',
      type: 'pie',
      labelLine: {
        length: 30
      },
      label: {
        color: '#2D5B5B',
        fontWeight: 'bold',
        fontSize: 14,
        opacity: 1
      },
      itemStyle: {
        color: theme.palette.primary.main,
        borderColor: '#fff',
        borderType: 'solid',
        borderWidth: 2
      },
      data: customData
    }]
  }), [customData]);
  return <Box component="div" width="100%" height={{
    none: '300px',
    sx: '400px'
  }} data-sentry-element="Box" data-sentry-component="QuarkDomainsDistribution" data-sentry-source-file="index.tsx">
      <ReactEChartsCore echarts={echarts} option={option} notMerge={true} lazyUpdate={true} theme={'theme_name'} style={{
      height: '100%',
      width: '100%'
    }} opts={{}} data-sentry-element="ReactEChartsCore" data-sentry-source-file="index.tsx" />
    </Box>;
};